/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface LandingPageToken { 
    codeLandingPage?: string;
    email?: string;
    id?: string;
    partner?: string;
    periodValidityMin?: number;
    schema?: string;
    tableId?: string;
    tableName?: string;
    time?: Date;
    uuid?: string;
}
